import { IUserInfo } from "../types/cookies.interface";

// ? ===============================================================================================================
// ? ================================================ Cookies Keys =================================================
// ? ===============================================================================================================

const USER_DIRECTION = "USER_DIRECTION";

// MD5 Hash
const USER: IUserInfo = {
  TYPE: "7e9bb28f90c6325ca4eecfe14b347887",
  TOKEN: "94c8aa2452bccd82ee129b46f7c4be79",
  AVATAR: "4aca1e1b04d4278630b19cf3faff4b29",
  BALANCE: "bd50bfdaa74e237144552ad497048642",
  IDENTIFY: "24edefac71a18dafc768b5234ce7d789",
  FULL_NAME: "187f3d0b5557774c1ed923a41d9491a6",
  FINANCIAL_PERMISSION: "051230055a9d87e70036e81e7f7bbe3f",
  WRITE_PERMISSION: "6ec4d19bd2868ebcf48b6c635cd0b56e",
  IS_PRIMARY_ADMIN: "172c366606f5e7786531b5aa1b1a5e51",
  COMPANY_DOCUMENTS: "17f3de99acf820355315ae84fa440a83",
  PROFIT_BALANCE: "aa2a90abab1f9703b1a080853a72aca2",
};

// ? ===============================================================================================================
// ? ============================================= WebSite Validation ==============================================
// ? ===============================================================================================================

// senjed
const BASE_URL: string = "https://api.tafkikapp.ir/api";
const BASE_URL_v2: string = "https://api.tafkikapp.ir/v2";
const SOCKET_URL: string = "https://api.tafkikapp.ir/";
const BASE_URL_FILE: string = "https://api.tafkikapp.ir/api";

const CODE_LOGOUT_USER = 402;
const CODE_REFRESH_TOKEN = 401;
const TITLE: string = "SenjedApp.ir";
const PROJECT_NAME: string = "پژواک داده‌ی خزر";
const PANEL_TABLE_DEFAULT_LIMIT: number = 10;
const ADMIN_NAME: string = "کارشناس سنجد";

const hardCodeCity = {
  _id: "63e362e6ae403e5554e3ac66",
  name: "taha",
  coords: [
    [36.943988, 50.611818],
    [36.89125, 50.656867],
    [36.909233, 50.685987],
    [36.944956, 50.64495],
  ],
  createdAt: "2023-02-08T08:52:54.585Z",
  updatedAt: "2023-02-16T10:24:53.173Z",
};

// !! ==============================================================================================================
// !! =========================================== RETURN CONSTANTS VALUES ==========================================
// !! ==============================================================================================================

const constants = {
  // PANEL VALUES

  BASE_URL,
  BASE_URL_v2,
  SOCKET_URL,
  BASE_URL_FILE,
  ADMIN_NAME,
  TITLE,
  PROJECT_NAME,
  USER_DIRECTION,
  CODE_LOGOUT_USER,
  PANEL_TABLE_DEFAULT_LIMIT,
  CODE_REFRESH_TOKEN,
  hardCodeCity,

  // USER VALUES
  USER,
};

export default constants;
